import { BotHeadSpin } from '../../../Components'
import { defineMessages, useIntl } from 'react-intl'
import { Text, Heading } from '@homebotapp/hb-react-component-catalog'

import styles from './Email.module.scss'

export const MSG = defineMessages({
  success: {
    id: 'NewBuyerSignUp.loginSuccessStep.success',
    defaultMessage: 'Success!'
  },
  loginSuccessDescription: {
    id: 'NewBuyerSignUp.loginSuccessStep.loginSuccessDescription',
    defaultMessage: 'Redirecting you to the Homebot app...'
  }
})

export const LoginSuccess = () => {
  const intl = useIntl()

  return (
    <div className={styles.emailStep}>
      <Heading textAlign='left'>{intl.formatMessage(MSG.success)}</Heading>
      <Text size='sm'>{intl.formatMessage(MSG.loginSuccessDescription)}</Text>
      <BotHeadSpin panelSpacing />
    </div>
  )
}
